<template>
    <vx-card title="Отключение объявлений GR" id="loader">
        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input v-model="form.historyDays" label="Период исторических данных (дней)" class="mt-1 w-full required" type="number" />
                </div>
            </div>
            <div class="vx-col w-1/2 right-aligin">
                <p>
                    Всего активных объявлений в GR: <b>{{ adsCount }}</b>
                </p>
            </div>
        </div>
        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input v-model="form.buyouts" label="Кол-во показов за период" class="mt-1 w-full required" type="number" />
                </div>
            </div>
            <div v-if="disabledAdIds.length > 0" class="vx-col w-1/2 right-aligin">
                <p>
                    Отключенные объявления в GR ({{ disabledAdIds.length }} шт.): <br /><b>{{ disabledAdIds }}</b>
                </p>
            </div>
        </div>
        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input v-model="form.adAgeDays" label="Мин. возраст объявления (дней)" class="mt-1 w-full required" type="number" />
                </div>
            </div>
        </div>
        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        v-model="form.dueTime"
                        label="Период запуска отключения объявлений по крону (минут)"
                        class="mt-1 w-full required"
                        type="number"
                    />
                </div>
            </div>
        </div>

        <vs-button class="mt-5 mr-2" color="danger" size="large" @click="sendClean()" type="filled"> Отключить </vs-button>
    </vx-card>
</template>

<script>
import vSelect from 'vue-select';
import axios from 'axios';
import STATUSES from 'config/statuses';

export default {
    name: 'category-edit',
    props: ['id'],
    data() {
        return {
            adsCount: 0,
            disabledAdIds: [],
            form: {
                historyDays: 5,
                buyouts: 1000,
                adAgeDays: 3,
                dueTime: 0
            }
        };
    },
    components: {
        'v-select': vSelect
    },
    methods: {
        loadData() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            this.axios
                .all([this.axios.get('ad-disabling/settings'), this.axios.get('ads/count', { params: { statusId: STATUSES.started } })])
                .then(
                    axios.spread((settings, count) => {
                        this.form.historyDays = settings.data.historyDays;
                        this.form.buyouts = settings.data.buyouts;
                        this.form.adAgeDays = settings.data.minAdAgeDays;
                        this.form.dueTime = settings.data.dueTime;
                        this.adsCount = count.data;
                    })
                )
                .catch((err, a) => {
                    if (err.response.status == 204) {
                        return this.$vs.notify({
                            title: 'Ошибка!',
                            text: 'Нет данных',
                            color: 'warning'
                        });
                    }
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка добавления новой задачи.',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });
        },
        sendClean() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            var params = {
                historyDays: this.form.historyDays == null ? 0 : this.form.historyDays,
                buyouts: this.form.buyouts == null ? 0 : this.form.buyouts,
                minAdAgeDays: this.form.adAgeDays == null ? 0 : this.form.adAgeDays,
                dueTime: this.form.dueTime == null ? 0 : this.form.dueTime
            };

            this.axios
                .all([
                    this.axios({
                        method: 'POST',
                        url: 'ad-disabling/',
                        data: params
                    })
                ])
                .then(
                    axios.spread((disabledAdIds) => {
                        this.disabledAdIds = disabledAdIds.data == null ? [] : disabledAdIds.data;
                        this.$vs.notify({
                            title: 'Успешно',
                            text: 'Отключено ' + this.disabledAdIds.length + ' объявлений',
                            color: 'success'
                        });

                        this.$vs.loading.close('#loader > .con-vs-loading');

                        this.loadData();
                    })
                )
                .catch((err) => {
                    var errText = 'Ошибка отключения объявлений';
                    if (err.response.status == 422 && err.response.data.errors) {
                        errText = '';
                        Object.keys(err.response.data.errors).forEach((key) => {
                            errText += err.response.data.errors[key] + ' ';
                        });
                    }

                    this.$vs.loading.close('#loader > .con-vs-loading');

                    return this.$vs.notify({
                        title: 'Ошибка!',
                        text: errText,
                        color: 'warning'
                    });
                });
        }
    },
    mounted() {
        this.loadData();
    }
};
</script>

<style>
.right-aligin {
    text-align: right;
}
</style>
